"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Error = _interopRequireDefault(require("../Error"));

var _Card = _interopRequireWildcard(require("../Card"));

var _Button = _interopRequireDefault(require("../Button"));

var _config = require("../config/config");

require("./cardModalError.sass");

var CardModalError = function CardModalError(_ref) {
  var onClose = _ref.onClose,
      title = _ref.title,
      message = _ref.message,
      okButtonLabel = _ref.okButtonLabel;
  return _react.default.createElement(_Card.default, {
    className: "card-modal-error"
  }, _react.default.createElement(_Card.CardClose, {
    onClick: onClose
  }), _react.default.createElement(_Card.CardContent, null, _react.default.createElement(_Error.default, {
    title: title,
    message: message
  })), _react.default.createElement(_Card.CardActions, null, _react.default.createElement(_Button.default, {
    primary: true,
    onClick: onClose
  }, okButtonLabel || (0, _config.__)('Ok'))));
};

CardModalError.propTypes = process.env.NODE_ENV !== "production" ? {
  title: _propTypes.default.string,
  message: _propTypes.default.string.isRequired,
  onClose: _propTypes.default.func.isRequired,
  okButtonLabel: _propTypes.default.node
} : {};
var _default = CardModalError;
exports.default = _default;